import getActionCreator from '../libs/getActionCreator';
import actionTypes from './actionTypes';

export const upgradeCost = getActionCreator(actionTypes.UPGRADE_COST);
export const upgrade = getActionCreator(actionTypes.UPGRADE);

export const cancelSubAction = getActionCreator(actionTypes.CANCEL_SUB);
export const reactivateSubscriptionAction = getActionCreator(actionTypes.REACTIVATE_SUB);
// eslint-disable-next-line import/prefer-default-export
export const setProfileInfo = getActionCreator(actionTypes.GET_PROFILE_INFO);
